import React from 'react';
import {VerifyUser} from './container';

export const VerifyUserScreen = ({navigation}: {navigation: any}) => {
  return <VerifyUser />;
};
